module.exports = __webpack_public_path__ + "img/bg_border.091d3f90.png";